"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resource_1 = require("../resource");
var components_1 = require("./components");
var product = /** @class */ (function (_super) {
    tslib_1.__extends(product, _super);
    function product() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.route = '/product';
        _this.components = new components_1.component();
        return _this;
    }
    /**
   *
   * @param {productListType} type? - The group of products to return. Valid values are accessible (default), selectable, and enterable. type can be a single value or an array of values if more than one group is needed with duplicates removed.
   * @returns {Promise<Array<number>>} Array of products id available.
   */
    product.prototype.list = function (type) {
        if (type === void 0) { type = "product_accessible" /* accessible */; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: "/" + type })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.ids];
                }
            });
        });
    };
    /**
   *
   * @param {Array<string | number> | string | number} id - id/s of products to retrieve.
   * @returns {Promise<Array<Product>>} Bug(s) which were requested.
   */
    product.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            params: { ids: Array.isArray(id) ? id.join("&ids=") : id },
                            // Axios encodes params by default. Bugzilla api doesnt like that.
                            // If this becomes a larger spread issue may consider creating a custom default serializer.
                            paramsSerializer: function (params) { return "ids=" + params.ids; }
                        })];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results.products];
                }
            });
        });
    };
    // TODO(Reece): retrieve the newly created product and return that instead of an ID. 
    /**
     * Create a new Bug in the Bugzilla database.
     *
     * @param {Bug} bug Bug object to be created. Required fields are defined in the Bug interface.
     * @returns {number} Return the ID of the created Bug.
     */
    product.prototype.create = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            method: 'POST',
                            data: product
                        })];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results.id];
                }
            });
        });
    };
    /**
     *
     * @param {number | Array<number>} ids Id(s) of the products to update.
     * @param update The update to carry out.
     */
    product.prototype.update = function (ids, update) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update.ids = Array.isArray(ids) ? ids : ids = [ids];
                        return [4 /*yield*/, this.makeRequest({
                                url: this.route + "/" + ids[0],
                                method: 'PUT',
                                data: update
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return product;
}(resource_1.resource));
exports.product = product;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/products/products.js
// module id = 984
// module chunks = 0